import React from 'react';
import { Button, useDisclosure } from '@chakra-ui/react';

import { AssetType } from 'entities/assets/model';
import { AssetsDocument } from 'features/asset/add-assets-modal/graphql/queries.gen';
import { GetAssetsDocument } from 'pages/art-catalog/ui/ArtCatalogTable/queries.gen';
import { ButtonType, trackAssetDeleted } from 'shared/analytics';
import { useAppToast } from 'shared/hooks/toast';
import { TrashBinIcon } from 'shared/icons';
import { EntityDeletionAlert } from 'shared/ui/entity-deletion-alert';

import { useDeleteHairMutation } from './queries.gen';

interface DeleteHairButtonProps {
	id: string;
	onCompleted: () => void;
}

export const DeleteHairButton: React.FC<DeleteHairButtonProps> = ({
	id,
	onCompleted,
}) => {
	const { isOpen, onClose, onOpen } = useDisclosure();
	const toast = useAppToast();
	const [deleteHair, { loading }] = useDeleteHairMutation({
		variables: { id },
		onCompleted: (data) => {
			toast({ title: 'Hair deleted successfully', status: 'success' });
			onCompleted();
			trackAssetDeleted({
				type: AssetType.HAIR,
				filename: data.deleteHair?.filename as string,
				link: data.deleteHair?.frontLink as string,
			});
		},
		onError: () => toast({ title: 'Hair was not deleted', status: 'error' }),
		refetchQueries: [AssetsDocument, GetAssetsDocument],
	});

	return (
		<>
			<Button
				disabled={loading}
				onClick={onOpen}
				leftIcon={<TrashBinIcon w={6} h={6} />}
			>
				Delete Hair
			</Button>
			{isOpen && (
				<EntityDeletionAlert
					isOpen={isOpen}
					onClose={onClose}
					onSubmit={deleteHair}
					buttonName={ButtonType.DELETE_HAIR}
					title="Hair Deletion"
					description="If you delete this hair, it can't be restored. Are you sure you want to continue?"
				/>
			)}
		</>
	);
};
